export default __webpack_public_path__ + "static/9-7b72b37ef42074e55a8dc03965efc640.jpg";